import React from "react";
import { Trans } from "react-i18next";
import {
  POLICY_DOCUMENTS,
  POLICY_LINK_CLASS_NAME,
} from "constants/moduleConstants/policy.constant";

const PolicyLink = ({ href, children }) => (
  <a
    href={href}
    target="_blank"
    rel="noopener noreferrer"
    className={POLICY_LINK_CLASS_NAME}
  >
    {children}
  </a>
);

const SignUpPolicyLabel = () => (
  <p>
    <Trans
      i18nKey="auth.signUp.form.policy.label"
      components={{
        consent: <PolicyLink href={POLICY_DOCUMENTS.CONSENT} />,
        membership: <PolicyLink href={POLICY_DOCUMENTS.MEMBERSHIP} />,
        cookie: <PolicyLink href={POLICY_DOCUMENTS.COOKIE} />,
      }}
    />
  </p>
);

export default SignUpPolicyLabel;
